(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chirachaya-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.chy-hdr-section');
    var header = section && section.querySelector('.chy-hdr--sticky');
    if (!header || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      header.classList.toggle('is-stuck', entries[0].intersectionRatio < 1);
    }, { threshold: [1] }).observe(section);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chirachaya-product-row"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (row) => {
      if (row.dataset.ready) return;
      row.dataset.ready = '1';
      const track = row.querySelector('.chy-row__track');
      const prev = row.querySelector('.chy-row__arrow--prev');
      const next = row.querySelector('.chy-row__arrow--next');
      if (!track || !prev || !next) return;
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.hidden = track.scrollLeft < 4;
        next.hidden = max < 4 || track.scrollLeft > max - 4;
      };
      const step = () => track.clientWidth * 0.9;
      prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
      next.addEventListener('click', () => track.scrollBy({ left: step() }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    };
    const init = () => document.querySelectorAll('[data-chy-row]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
